export default "__VITE_PUBLIC_ASSET__2eb66eb4__"